<template>
  <div class="full flex column">
    <div class="hd flex-center column" style="height: 120px;">
      <div class="pt">累计访问人次</div>
      <count-to class="font-5x text-green" :start-val="lastTotalNum" :end-val="totalNum" />
    </div>
    <div class="bd">
      <div id="visit-stats-chart" class="full" style="height: 195px;" />
    </div>
  </div>
</template>

<script>
import { debounce } from '@/utils/common'
import { getVisitStatsApi } from '@/api/rms/rmsEventApi'
export default {
  data() {
    return {
      totalNum: 0,
      lastTotalNum: 0,

      timerId: null,
      pingCounter: 0,
      pingCt: 5,

      statsChart: undefined,
      statsChartOption: {
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          top: 30,
          bottom: 30
        },
        textStyle: {
          fontSize: 12,
          color: '#dddddd'
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(128, 128, 128, .1)'
            }
          },
          data: []
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(128, 128, 128, .5)'
            }
          }
        },
        series: [
          {
            name: '用户活跃度',
            type: 'line',
            color: '#07c160',
            data: []
          }
        ]
      }
    }
  },

  created() {
    this.fetchStatsData()
    this.initInterval()
  },

  mounted() {
    this.initStatsChart()
    this.__resizeHandler = debounce(() => {
      if (this.statsChart) {
        this.statsChart.resize()
      }
    }, 100)
    window.addEventListener('resize', this.__resizeHandler)
  },

  beforeDestroy() {
    if (this.statsChart) {
      this.statsChart.dispose()
      this.statsChart = undefined
    }
    window.removeEventListener('resize', this.__resizeHandler)
    this.stopInterval()
  },

  methods: {
    initInterval() {
      var _this = this
      _this.pingCounter = 0
      _this.stopInterval()
      this.timerId = setInterval(function() {
        // 周期ping
        _this.pingCounter += 1
        if (_this.pingCounter >= _this.pingCt) {
          _this.pingCounter = 0
          _this.fetchStatsData()
        }
      }, 1000)
    },
    stopInterval() {
      if (this.timerId) {
        clearInterval(this.timerId)
        this.timerId = null
      }
    },

    fetchStatsData() {
      getVisitStatsApi().then(res => {
        if (!res.errno) {
          this.lastTotalNum = this.totalNum
          this.totalNum = res.data.sum_visit

          this.statsChartOption.xAxis.data = res.data.date
          this.statsChartOption.series[0].data = res.data.daily
          this.refreshStatsChart()
        }
      })
    },

    initStatsChart() {
      this.statsChart = this.$echarts.init(document.getElementById('visit-stats-chart'), 'teenager')
      this.refreshStatsChart()
    },

    refreshStatsChart() {
      if (this.statsChart) {
        this.statsChart.setOption(this.statsChartOption)
      }
    }
  }
}
</script>
